import { Text } from '@cinch-labs/design-system'
import { useViewport } from '@cinch-labs/shared-util'
import { useState } from 'react'

import styles from './finance-example.module.css'

export interface FinanceExampleProps {
  heading: string
  body: string
  financeItems: FinanceItem[]
}

interface FinanceItem {
  term: string
  details: string
}

const showBreakdownText = 'Show example breakdown'
const hideBreakdownText = 'Hide example breakdown'

const renderRepExItem = (item: FinanceItem) => (
  <div data-testid="example-item" key={item.term} className={styles.repExItem}>
    <Text
      element="dt"
      fontSizeFixed="xs"
      fontWeight="book"
      className={styles.repExItemHeader}
    >
      {item.term}
    </Text>
    <Text element="dd" fontSizeFixed="xs" fontWeight="bold">
      {item.details}
    </Text>
  </div>
)

const FinanceExample: React.FC<FinanceExampleProps> = ({
  heading,
  body,
  financeItems,
}) => {
  const { vw } = useViewport({
    updateOnResize: true,
    updateOnOrientationChange: true,
  })
  const isMobile = vw < 1024

  const [showBreakdown, setShowBreakdown] = useState(false)

  return (
    <section
      className={styles.repExSection}
      aria-labelledby="representativeExampleHeading"
    >
      <div className={styles.innerContainer}>
        <div className={styles.repExHeader}>
          <Text
            id="representativeExampleHeading"
            element="h3"
            fontWeight="bold"
            className={styles.repExTitle}
          >
            {heading}
          </Text>

          <Text
            fontWeight="book"
            className={styles.repExBody}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </div>

        {isMobile && (
          <div
            className={styles.showBreakdown}
            onClick={() => setShowBreakdown(!showBreakdown)}
          >
            {showBreakdown ? hideBreakdownText : showBreakdownText}
          </div>
        )}

        {(showBreakdown || !isMobile) && (
          <dl className={styles.repExItemList}>
            {financeItems.map((item) => renderRepExItem(item))}
          </dl>
        )}
      </div>
    </section>
  )
}

export default FinanceExample
